import { PaymentMethod, PaymentMethodsType } from '@monofront/types';

export const getIsCardNotExpired = (paymentMethod: PaymentMethod): boolean =>
  paymentMethod.paymentType === PaymentMethodsType.Card &&
  new Date(paymentMethod.exp_year, paymentMethod.exp_month).getTime() -
    new Date().getTime() >
    0;
